import { FC, useMemo } from 'react';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

import { LANGUAGE_STATUS } from './constants';
import { LanguagePickerProps, LanguageStatusType } from './types';

const StatusCircle: FC<{ status: LanguageStatusType }> = ({ status }) => {
  if (status === LANGUAGE_STATUS.EMPTY) return null;

  const color = status === LANGUAGE_STATUS.COMPLETE ? 'bg-green-500' : 'bg-yellow-500';

  return (
    <div className={`w-2 h-2 rounded-full ${color}`} />
  );
};

export const LanguagePicker: FC<LanguagePickerProps> = ({
  dataTestId,
  listDataTestId,
  languages,
  defaultSelectedLanguage,
  onChange,
  className,
  languageStatus = {}
}) => {
  const enabledLanguages = useMemo(() => {
    return languages.map(({ language, isoCode }) => {
      const status = languageStatus[isoCode] || LANGUAGE_STATUS.EMPTY;

      return {
        label: language,
        value: isoCode,
        rightIcon: <StatusCircle status={status} />
      };
    });
  }, [languages, languageStatus]);

  if (!enabledLanguages.length || enabledLanguages.length === 1) return null;

  return (
    <InputSelectDropdown
      label="Localization"
      defaultSelected={defaultSelectedLanguage}
      options={enabledLanguages}
      onOptionChange={onChange}
      className={className}
      buttonDataTestId={dataTestId}
      listDataTestId={listDataTestId}
    />
  );
};
